<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="form-group pb-3 mt-2 form-show-validation row" v-if="user.custom_label || artists.length > 1">
        <div class="col-lg-3">
          <input type="text" v-model="searchFilter" class="form-control mb-2" :placeholder="$t('search')">
        </div>
        <div class="col-lg-3">
          <div class="select2-input mb-2">
            <Select2 v-model="filterByArtist" :options="artists"></Select2>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="select2-input mb-2">
            <Select2 v-model="tab" :options="statusOptions"></Select2>
          </div>
        </div>
        <div class="col-lg-3">
          <div v-if="!(strikesCount >= 2 && user.freeze)" class="d-inline">
            <span v-if="!availableDistributions">
              <button v-if="user.verified" @click="validateServices()" class="btn btn-gradient btn-block new-button text-white"><i class="fas fa-plus"></i> {{ $t('new_release') }}</button>
              <button v-else @click="showNotificationLimitReached()" class="btn btn-gradient btn-block new-button text-white"><i class="fas fa-plus"></i> {{ $t('new_release') }}</button>
            </span>
            <span v-else-if="availableDistributions && !user.freeze">
              <router-link v-if="locationSettings.hide_basic" to="/upgrade?from=distributions_location_limit" class="btn btn-gradient btn-block new-button text-white">
                <i class="fas fa-plus mr-1"></i>{{ $t('new_release') }}
              </router-link>
              <router-link v-if="!locationSettings.hide_basic" to="/new-distribution" class="btn btn-gradient btn-block new-button text-white">
                <i class="fas fa-plus mr-1"></i>{{ $t('new_release') }}
              </router-link>
            </span>
            <div class="mt-3 text-small" v-if="!user.subscription || (user.subscription && user.subscription.plan_name === 'indiefy_lite')">
              {{ availableDistributions }} {{ $t('remaining_releases') }} <span v-if="!availableDistributions && moment().add(1, 'months').startOf('month').diff(new Date(), 'days') > 0">({{ moment().add(1, 'months').startOf('month').diff(new Date(), 'days') }} {{ $t('days_to_restart') }})</span>
            </div>
          </div>
          <div v-if="strikesCount >= 2 && user.freeze" class="d-inline mb-1">
            <button type="button" class="btn btn-gradient btn-block" @click="showStrikesModal()"><i class="fas fa-plus"></i> {{ $t('new_release') }}</button>
          </div>
        </div>
      </div>
      <div class="alert alert-warning mt-2" v-if="moment.utc().isBefore('2023-01-03')">
        <label v-html="$t('release_date_holidays')"></label>
      </div>
    </div>
    <div class="page-inner">

      <!-- <div v-if="!user.subscription" class="text-center mb-3 mt-3">
        <ins class="adsbygoogle"
            style="display:block"
            data-ad-client="ca-pub-8326584585992829"
            data-ad-slot="8454890613"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
      </div> -->

      <div class="p-5 text-center" v-if="loading">
        <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
      </div>

      <p v-if="!loading && !filteredDistributions.length" class="text-muted">
        <span v-if="!allDistros">
          {{ $t('no_releases_yet') }}
        </span>
      </p>

      <div class="row row-projects" v-if="!loading">
        <div class="col-sm-12 col-md-4 col-lg-3" v-for="item in filteredDistributions" v-bind:key="item._id">
          <div class="card distribution-container position-relative box make-it-slow">
            <i class="fas fa-ellipsis-h drop-button" data-toggle="dropdown"
              v-if="
                !item.inactive &&
                (
                  item.status === 3 ||
                  item.spotify_url ||
                  item.status === 5 ||
                  (item.release_type === 'single' && (item.status === 3 || item.status === 2 || item.status === 5) && item.songs[0].isrc) ||
                  ((item.status === 2 || item.status === 3 || item.status === 5) && !user.freeze)
                )
              "
            ></i>
            <div class="dropdown-menu dropdown-menu-right distro-options" x-placement="bottom-end" style="position: absolute; transform: translate3d(-124px, 25px, 0px); top: 0px; left: 0px; will-change: transform;">
              <button class="dropdown-item pl-3 pr-3" v-if="item.status === 3" @click="copyText(`https://indfy.me/${item.key}`, 'Smartlink')">
                <i class="far fa-clipboard"></i>
                {{ $t('copy_smartlink') }}
              </button>
              <button class="dropdown-item pl-3 pr-3"
                v-if="item.release_type === 'single' && (item.status === 3 || item.status === 2) && item.songs[0].isrc"
                @click="copyText(item.songs[0].isrc, 'ISRC')"
              >
                <i class="far fa-clipboard"></i>
                {{ $t('copy_isrc') }}
              </button>
              <button class="dropdown-item pl-3 pr-3" v-if="item.spotify_url" @click="copyText(spotifyUrl(item), 'URI')">
                <i class="far fa-clipboard"></i>
                {{ $t('copy_spotify_uri') }}
              </button>
              <div class="mt-5"
                v-if="
                  (item.status === 3 ||
                  item.spotify_url ||
                  (item.release_type === 'single' && (item.status === 3 || item.status === 2) && item.songs[0].isrc)) &&
                  ((item.status === 2 || item.status === 3))
                "
              >
                &nbsp;
              </div>
              <div class="mt-5"
                v-if="
                  (item.status === 5 ||
                  item.spotify_url ||
                  (item.release_type === 'single' && (item.status === 5 || item.status === 2) && item.songs[0].isrc)) &&
                  ((item.status === 2 || item.status === 5))
                "
              >
                &nbsp;
              </div>
              <button class="dropdown-item pl-3 pr-3 takedown-release" v-if="item.status === 3" @click="showTakedownModal(item)">
                <i class="fas fa-trash"></i>
                {{ $t('takedown_request') }}
              </button>
              <button class="dropdown-item pl-3 pr-3 takedown-release" v-if="item.status === 5" @click="cancelTakedown(item)">
                <i class="fas fa-trash" ></i>
                {{ $t('cancel_takedown_request') }}
              </button>
            </div>
            <a href="javascript:void(0)" class="text-center" @click="getDistributionUrl(item)">
              <img
                class="card-img-top rounded"
                :src="item.cover_image_small || item.cover_image || defaultImage"
                :alt="item.title"
                onerror="this.src = '/static/img/img-placeholder.jpg'"
              />
              <div class="text-left">
                <h4 class="mb-1 fw-bold m-0 title-distro">{{ item.title }}</h4>
                <div class="name-artist">{{ item.artist.name }}</div>
                <div class="text-muted" v-if="item.upc">UPC: {{ item.upc }}</div>
                <p class="small mb-2 date-release">
                  <span v-if="item.status === 3">{{ $t('published') }}</span>
                  <span v-else>
                    {{ $t('release_date') }}
                  </span>
                  : {{ moment.utc(item.release_date).format('LL') }}
                </p>
              </div>
              <div class="text-right status-distro-container">
                <span class="status-distro"
                  :class="{
                    'status-in-process': item.status === 2, //in_process
                    'status-unset': item.status === 0 && !item.reopening_reason, //unsent
                    'status-reopened': item.status === 0 && item.reopening_reason, //reopened
                    'status-published': item.status === 3, //published
                    'status-rejected-more': contains([6, 5, 4], item.status), //rejected - takedown_requested - unpublished
                    'status-in-review': item.status === 1 //in_review
                  }"
                >
                  <i class="fas fa-exclamation-triangle" v-if="contains([6, 5, 4], item.status) || (item.status === 0 && item.reopening_reason)"></i>
                  <i class="fas fa-circle" v-else></i>
                  {{ getStatus(item) }}
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- <div v-if="!user.subscription" class="text-center mb-3 mt-3">
        <ins class="adsbygoogle"
            style="display:block"
            data-ad-client="ca-pub-8326584585992829"
            data-ad-slot="8454890613"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
      </div> -->
    </div>
    <div ref="strikeModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="text-center my-4">
            <div style="font-size: 70px">
              <span class="text-danger">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <p class="strong h2">{{ $t('two_strike_title') }}</p>
            </div>
          </div>
          <div class="modal-body">
            <p class="mx-4" v-html="$t('two_strike_title_text')"></p>
            <p class="mx-4">{{ $t('two_strike_title_text2') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal">{{ $t('understood') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div ref="unsentDistrosModal" class="modal light-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <div class="row">
              <div class="col-lg-12">
                <div class="pt-4 pb-4 title" style="">{{ $t('attention') }}</div>
                <br><br>
                <div class="mt-4 description">
                  <b>{{ $t('you_have_unsent_releases') }}</b>
                  <br>
                  {{$t('please_delete_unsent_distros')}}
                </div>
                <div class="mt-4 button-container">
                  <button type="button" class="btn btn-primary" data-dismiss="modal">{{ $t('understood') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="takedownModal" class="modal modal-swal modal-h" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t('takedown_distribution') }}
          </div>
          <div class="modal-body">
            <div v-if="modalTakedownStep === 1">
              <p v-html="`<i class='fas fa-exclamation-triangle text-danger mr-1'></i>` + $t('takedown_warning_description')"></p>
              <div class="form-check pl-0 my-2 ml-4">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" value="" v-model="takedownAgree1" :disabled="currentDistro.takedown_object">
                  <span class="form-check-sign">{{ $t('takedown_yes_im_sure') }}</span>
                </label>
              </div>
              <p v-html="$t('takedown_proccess_info')"></p>
              <div class="form-check pl-0 my-2 ml-4">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" value="" v-model="takedownAgree2" :disabled="currentDistro.takedown_object">
                  <span class="form-check-sign">{{ $t('i_understand') }}</span>
                </label>
              </div>
              <div v-show="takedownAgree1 && takedownAgree2" class="animated fadeIn">
                <span>{{ $t('takedown_reason_text') }}<span class="text-danger ml-1 strong">*</span></span>
                <div class="mt-2">
                  <select class="form-control" style="height: 38px !important;" v-model="takedownReason" :disabled="currentDistro.takedown_object">
                    <option value="">{{ $t('takedown_reason_option_0') }}</option>
                    <option value="mistake">{{ $t('takedown_reason_option_1') }}</option>
                    <option value="release-copyright">{{ $t('takedown_reason_option_2') }}</option>
                    <option value="release-not-in-stores">{{ $t('takedown_reason_option_3') }}</option>
                    <option value="no-streams">{{ $t('takedown_reason_option_4') }}</option>
                    <option value="no-royalties">{{ $t('takedown_reason_option_5') }}</option>
                    <option value="other">{{ $t('other') }}</option>
                  </select>
                  <div v-if="takedownReason === 'other'">
                    <label class="my-2">{{ $t('reason') }}:<span class="text-danger ml-1 strong">*</span></label>
                    <textarea class="form-control" rows="4" maxlength="150" v-model="takedownOtherReason" :disabled="currentDistro.takedown_object"></textarea>
                    <small class="float-left text-danger">{{ $t('minimum') }} 20 {{ $t('characters')}}</small><small class="float-right text-danger">{{ $t('maximum') }} 150 {{ $t('characters')}}</small>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="modalTakedownStep === 2">
              <div class="text-center">
                <span class="text-success bold-600" v-if="takedownFree">
                  {{ $t('available') }}
                </span>
                <span class="text-danger bold-600" v-else>
                  {{ $t('not_available') }}
                </span>
              </div>
              <br>
              <span v-if="takedownFree" v-html="$t('takedown_free_payment_description')"></span>
              <span v-else v-html="$t('takedown_force_payment_description').replace('%s', takedownDaysLimit)"></span>
              <p v-if="!takedownFree" class="mt-3">
                <b><i class="fa fa-exclamation-triangle mr-1 text-warning"></i>{{ $t('warning') }}:</b> {{ $t('dmca_claim_warning') }}
              </p>
            </div>
          </div>
          <div class="modal-footer pt-5">
            <button type="button" class="btn btn-default btn-border no-border" data-dismiss="modal" @click="hideTakeDownModal()">{{ $t('cancel') }}</button>
            <button type="button" @click="modalTakedownStep = 2" class="btn btn-primary" v-if="modalTakedownStep === 1" :disabled="takedownDisableNextStep()">{{ $t('next') }}</button>
            <button type="button" @click="takedown(takedownFree)" class="btn btn-primary" v-if="modalTakedownStep === 2" :disabled="loadingTakedown">
              <i v-if="loadingTakedown" class="fa fa-spinner fa-spin"></i>
              <span v-if="takedownFree">{{ $t('request') }}</span>
              <span v-else>{{ $t('upgrade_to_pro') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <UpgradeModal referrer="distributions"></UpgradeModal>

    <div ref="playlistModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="mb-0"><span class="badge badge-primary mr-1">PRO</span> Playlist Promotion </h3>
          </div>
          <div class="modal-body" v-html="$t('new_release_playlist_modal')">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('close') }}</button>
            <router-link to="/upgrade?from=new-release-playlists" type="button" class="btn btn-gradient">{{ $t('upgrade_now') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from './utils/Select2'
import _ from 'underscore'
import moment from 'moment'
import Distributions from '../services/distributions'
import Labels from '../services/labels'
import User from '../services/user'
import Artists from '../services/artists'
import Configuration from '../services/configuration'
import ServicesOnDemand from '../services/services-on-demand'
import UpgradeModal from './utils/UpgradeModal'
import Public from '../services/public'

export default {
  name: 'Distributions',
  data () {
    return {
      locationSettings: {},
      availableDistributions: 0,
      tab: 'all',
      searchFilter: '',
      defaultImage: '/static/img/img-placeholder.jpg',
      loading: true,
      distributions: [],
      allDistros: 0,
      published: 0,
      unsent: 0,
      reopened: 0,
      rejected: 0,
      review: 0,
      contains: _.contains,
      moment: moment,
      user: {},
      artists: [],
      labels: [],
      filterByLabel: '',
      filterByArtist: '',
      strikesCount: 0,
      isPro: false,
      takedownReason: '',
      takedownOtherReason: '',
      takedownAgree1: false,
      takedownAgree2: false,
      freeTakedownRemainingDays: 0,
      currentDistro: {
        release_date: null,
        status: null,
        approved_on: null,
        takedown_object: null
      },
      AlertBannerBeatport: false,
      now: '',
      partnerize: false,
      camref: '',
      modalTakedownStep: 1,
      takedownDaysLimit: 180,
      loadingTakedown: false,
      takedownFree: null,
      stripe: null,
      statusOptions: [
        { id: 'all', text: this.$t('all_releases') },
        { id: 'review', text: this.$t('review') },
        { id: 'published', text: this.$t('published') },
        { id: 'reopened', text: this.$t('reopened') },
        { id: 'rejected', text: this.$t('rejected') },
        { id: 'unsent', text: this.$t('unsent') }
      ]
    }
  },
  computed: {
    filteredDistributions: function () {
      let filtered = this.distributions

      if (this.searchFilter) {
        filtered = _.filter(filtered, item => {
          return (item.upc && item.upc.toLowerCase().includes(this.searchFilter.toLowerCase())) || (item.title && item.title.toLowerCase().includes(this.searchFilter.toLowerCase()))
        })
      }

      if (this.tab === 'all') {
        return filtered
      } else if (this.tab === 'published') {
        return _.filter(filtered, item => item.status === 3)
      } else if (this.tab === 'reopened') {
        return _.filter(filtered, item => item.status === 0 && item.reopening_reason)
      } else if (this.tab === 'rejected') {
        return _.filter(filtered, item => item.status === 4 || item.status === 5)
      } else if (this.tab === 'unsent') {
        return _.filter(filtered, item => item.status === 0 && !item.reopening_reason)
      } else if (this.tab === 'review') {
        return _.filter(filtered, item => item.status === 1)
      }
    }
  },
  methods: {
    getDistributionUrl: function (item) {
      if (this.user.freeze) {
        return this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      }
      if (item.status === 0) {
        if (item.reopening_reason) {
          this.$router.push(`/distributions/${item._id}/reopening-details`)
        } else {
          this.$router.push(`/distributions/${item._id}`)
        }
      } else if (item.status === 3) {
        this.$router.push(`/distributions/${item._id}/links`)
      } else {
        if (item._id) {
          this.$router.push(`/distributions/${item._id}/details`)
        } else {
          this.$router.push(`/distributions`)
        }
      }
    },
    getStatus: function (item) {
      if (item.status === 0 && !item.reopening_reason) {
        return this.$t('unsent')
      } else if (item.status === 0 && item.reopening_reason) {
        return this.$t('reopened')
      } else if (item.status === 1) {
        return this.$t('in_review')
      } else if (item.status === 2) {
        return this.$t('in_process')
      } else if (item.status === 3) {
        return this.$t('published')
      } else if (item.status === 4) {
        return this.$t('rejected')
      } else if (item.status === 5) {
        return this.$t('takedown_requested')
      } else if (item.status === 6) {
        return this.$t('unpublished')
      }
    },
    getReleases: function () {
      this.loading = true

      Distributions.getAll({ artist: this.filterByArtist, custom_label: this.filterByLabel }).then(response => {
        this.distributions = response.data
        this.loading = false

        this.distributions = _.filter(
          this.distributions,
          item => item.status !== 6
        )
        this.allDistros = _.filter(
          this.distributions,
          item => item.status !== 5
        ).length
        this.published = _.filter(
          this.distributions,
          item => item.status === 3
        ).length
        this.rejected = _.filter(
          this.distributions,
          item => item.status === 4 || item.status === 5
        ).length
        this.reopened = _.filter(
          this.distributions,
          item => item.status === 0 && item.reopening_reason
        ).length
        this.unsent = _.filter(
          this.distributions,
          item => item.status === 0 && !item.reopening_reason
        ).length
        this.review = _.filter(
          this.distributions,
          item => item.status === 1
        ).length

        let getBeatport = 0
        _.each(this.distributions, (distro) => {
          if (distro.dsps) {
            _.each(distro.dsps, (dsp) => {
              if (parseInt(dsp.dsp) === 89882) {
                getBeatport = 1
              }
            })
          }
        })
        if (getBeatport) {
          User.getAlertBannerBeatport().then(response => {
            if (response.data.show_tutorial) {
              this.AlertBannerBeatport = true
              this.$forceUpdate()
            }
          }).catch(error => {
            console.error('Error on getAlertBannerBeatport (2)', error)
          })
        }
      }).catch((error) => {
        console.error('Error while trying to get all releases (distributions/getReleases)', error)
      })
    },
    showStrikesModal: function () {
      window.$(this.$refs.strikeModal).modal('show')
    },
    validateServices: function () {
      ServicesOnDemand.getServicesBy('extra_distro').then(response => {
        if (response.data.length) {
          this.$router.push(`/new-distribution`)
        } else {
          this.$eventBus.$emit('showUpgradeModal', '', 'distribution_limit')
        }
      }).catch((error) => {
        console.error('Error while trying to validate services', error)
      })
    },
    showNotificationLimitReached: function () {
      this.$eventBus.$emit('showUpgradeModal', '', 'distribution_limit')
    },
    copyText: function (txt, title) {
      if (typeof txt !== 'undefined') {
        let aux = document.createElement('input')
        aux.setAttribute('value', txt)
        document.body.appendChild(aux)
        aux.select()
        document.execCommand('copy')
        document.body.removeChild(aux)
        this.$notify({ message: this.$t('something_copied').replace('<br>', title) }, 'success', 'fa-check')
      }
    },
    showTakedownModal: function (item) {
      Configuration.now().then(response => {
        this.now = response.data.now_iso
        this.currentDistro = item
        if (this.currentDistro.status === 3) {
          this.takedownDaysLimit = this.isPro ? 0 : 180
          this.takedownFree = moment(this.now).diff(moment(this.currentDistro.release_date), 'day') >= this.takedownDaysLimit
          if (this.currentDistro.takedown_object) {
            this.takedownAgree1 = true
            this.takedownAgree2 = true
            this.takedownReason = this.currentDistro.takedown_object.takedown_reason
            this.takedownOtherReason = this.currentDistro.takedown_object.takedown_reason_other
          }
          window.$(this.$refs.takedownModal).modal('show')
        }
      }).catch(error => {
        console.error('Error while trying to call Configuration.now', error)
      })
    },
    cancelTakedown: async function (item) {
      let resultDistributions = await Distributions.cancelTakedown(item._id)

      if (resultDistributions.data && resultDistributions.data.success) {
        this.$notify({ message: this.$t('cancel_takedown_request') }, 'success', 'fa-check')
        setTimeout(() => {
          this.getReleases()
        }, 1500)
      } else {
        if (resultDistributions) {
          this.$notify({ message: resultDistributions.data.error }, 'warning', 'fa-exclamation')
        }
      }
    },
    hideTakeDownModal: function () {
      this.takedownReason = ''
      this.takedownOtherReason = ''
      this.takedownAgree1 = false
      this.takedownAgree2 = false
      this.freeTakedownRemainingDays = 0
      this.currentDistro = {
        release_date: null,
        status: null,
        approved_on: null,
        takedown_object: null
      }
      this.modalTakedownStep = 1
      this.takedownDaysLimit = 180
      this.takedownFree = null
    },
    emptyOtherReason: function () {
      return this.takedownReason === 'other' && this.takedownOtherReason.length < 20
    },
    takedownDisableNextStep: function () {
      return (!this.takedownAgree1 || !this.takedownAgree2 || !this.takedownReason || this.emptyOtherReason())
    },
    takedown: function (isFree) {
      if (this.validateTakedownReason()) {
        this.loadingTakedown = true
        let dataToSend = {
          takedown_reason: this.takedownReason,
          takedown_reason_other: this.takedownOtherReason
        }

        if (isFree || this.user.subscription) {
          Distributions.setTakedown(this.currentDistro._id, dataToSend).then(response => {
            this.loadingTakedown = false
            window.$(this.$refs.takedownModal).modal('hide')
            this.$notify({ message: this.$t('takedown_sent') }, 'success', 'fa-check')
            setTimeout(() => {
              window.location.href = `/distributions/`
            }, 1500)
          }).catch((error) => {
            console.log('Error on setTakedown', error)
          })
        } else {
          this.$router.push(`/upgrade?from=takedown`)
        }
      }
    },
    validateTakedownReason: function () {
      let response = false
      if (!this.takedownDisableNextStep()) {
        response = true
      }
      return response
    },
    activateAlertBannerBeatport: function () {
      User.saveAlertBannerBeatport().then(() => {
        this.AlertBannerBeatport = false
      }).catch((error) => {
        console.error('Error on saveAlertBannerBeatport', error)
      })
    },
    spotifyUrl: function (distro) {
      let pufRef = encodeURIComponent([
        't2', // origin distro all
        distro.title,
        distro.artist.name,
        moment(distro.release_date).format('YYYY/MM')
      ].join(', '))
      console.log(decodeURIComponent(pufRef))
      return this.partnerize ? `https://prf.hn/click/camref:${this.camref}/pubref:${pufRef.substring(0, 255)}/destination:${encodeURIComponent(distro.spotify_url)}` : distro.spotify_url
    },
    upgradeToPro: function () {
      this.$router.push(`/upgrade?from=release`)
    }
  },
  created: function () {
    this.user = this.$user
    this.getReleases()
    this.isPro = !!this.$user.subscription
    this.stripe = window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm')

    User.getCurrentStrikes({ userId: this.user._id }).then((response) => {
      this.strikeItems = response.data || []
      this.strikesCount = this.strikeItems.length
    }).catch(error => {
      console.error('Error on getCurrentStrikes', error)
    })

    Distributions.getAvailableDistributions().then(response => {
      this.availableDistributions = response.data.available

      if (response.data.available <= 0) {
        window.ga && window.ga('send', {
          hitType: 'event',
          eventCategory: 'Distributions',
          eventAction: 'Distribution Limit',
          eventLabel: 'Limit Reached'
        })
      }
    }).catch((error) => {
      console.error('Error while trying to get distribution limit (distributions)', error)
      this.availableDistributions = 1
    })

    Artists.getAll().then(response => {
      this.artists = [{ id: '', text: this.$t('all_artists') }].concat(_.map(response.data, (item) => {
        return {
          id: item._id,
          text: item.name
        }
      }))
    }).catch(error => {
      console.error('Error while trying to get all artists (distributions page)', error)
    })

    if (this.$route.query.non_verif_limit) {
      this.$notify({ message: this.$t('resolve_application_first') }, 'warning', 'fa-exclamation')
    }

    if (this.$route.query.success_takedown) {
      this.$notify({ message: this.$t('takedown_sent') }, 'success', 'fa-check')
    }

    if (this.$route.query.cancelled_takedown) {
      this.$notify({ message: this.$t('takedown_cancelled_payment') }, 'warning', 'fa-exclamation')
    }

    if (this.$route.query.missing_status) {
      this.$notify({ message: this.$t('missing_status') }, 'warning', 'fa-exclamation')
    }

    if (this.$route.query.missing_id) {
      this.$notify({ message: this.$t('missing_id') }, 'warning', 'fa-exclamation')
    }

    if (this.$route.query.service_extra_distro) {
      this.$notify({ message: this.$t('service_extra_distro_success') }, 'success', 'fa-check')
    }

    if (this.$route.query.service_content_id) {
      this.$notify({ message: this.$t('service_content_id_success') }, 'success', 'fa-check')
    }

    if (this.$route.query.service_metadata_request) {
      this.$notify({ message: this.$t('service_metadata_request_success') }, 'success', 'fa-check')
    }

    if (this.$route.query.missing_service) {
      this.$notify({ message: this.$t('missing_service') }, 'success', 'fa-check')
    }

    Public.getLocationSettings().then(response => {
      this.locationSettings = response.data
    }).catch((error) => {
      console.error('Error while trying to get location settings', error)
    })
  },
  mounted: async function () {
    if (this.user.custom_label) {
      Labels.getAll().then(response => {
        this.labels = _.map(response.data, item => {
          return { id: item._id, text: item.name }
        })
        let defaultOption = {
          id: '',
          text: this.$t('all_labels')
        }
        this.labels.unshift(defaultOption)
      }).catch(error => {
        console.error('Errow while trying to get labels (distributions)', error)
      })
    }
    if (this.$route.query.unsentDistros && !this.$user.subscription) {
      return window.$(this.$refs.unsentDistrosModal).modal('show')
    }

    window.$(document).off('mouseenter', '.drop-button')
    window.$(document).on('mouseenter', '.drop-button', function () {
      window.$(this).trigger('click')
    })

    window.$(document).off('mouseleave', '.distribution-container ')
    window.$(document).on('mouseleave', '.distribution-container ', function () {
      if (window.$(this).find('.dropdown-menu').hasClass('show')) {
        window.$(this).find('.drop-button').trigger('click')
      }
    })

    let config = await Configuration.get({fields: ['partnerize', 'camref']})
    this.partnerize = config.data.partnerize
    this.camref = config.data.camref

    if (this.$route.query.distribution_created && !this.user.subscription) {
      window.$(this.$refs.playlistModal).modal('show')
    }

    // if (!this.user.subscription) {
    //   setTimeout(() => {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }, 100)
    // }
  },
  components: {
    Select2,
    UpgradeModal
  },
  watch: {
    filterByLabel: function () {
      this.getReleases()
    },
    filterByArtist: function () {
      this.getReleases()
    }
  }
}
</script>

<style lang="scss" scoped>
  .distribution-container {
    padding: 15px;
    i.fas.fa-ellipsis-h {
      position: absolute;
      top: 20px;
      right: 20px;
      background: #5714ff;
      color: #fff;
      width: 30px;
      height: 30px;
      text-align: center;
      font-size: 20px;
      line-height: 30px;
      border-radius: 3px;
      cursor: pointer;
    }
    h4.mb-1.fw-bold {
      padding-top: 30px;
    }
    &:hover {
      a {
        text-decoration: none;
      }
    }
    .status-distro-container {
      padding-top: 20px;
    }
    .status-distro{
      font-weight: 500;
      i{
        font-size: 10px;
        padding-right: 5px;
      }
    }
    .status-in-process {
      color: #48ACF7;
    }
    .status-unset {
      color: #192135
    }
    .status-reopened {
      color: #FFAB00;
    }
    .status-published {
      color: #31ce36
    }
    .status-rejected-more {
      color: #FF0000;
    }
    .status-in-review {
      color: #5714ff;
    }
    .status-takedown-pending {
      color: #6e5115;
    }
    .name-artist {
      color: #212529;
    }
    .date-release {
      color: #8C96A3;
    }
    .distro-options {
      min-width: 13rem;

      .dropdown-item {
        i {
          padding-right: 10px;
        }
      }

      button {
        cursor: pointer;
        color: #8C96A3;
        &:hover, &:active {
          color: #5714ff;
        }
        &:active {
          background: #f8f9fa;
        }
      }
      .takedown-release {
        transition: all ease 0.2s;
        &:hover {
          color: #FFAB00;
        }
      }
    }
  }
  .iconplus{
    font-size: 15px;
    padding-right: 5px;
    vertical-align: inherit;
  }
  .box {
    box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    transition: all 0.3s ease-in-out;
  }
  .box::after {
    content: '';
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    transition: opacity 0.3s ease-in-out;
  }
  .make-it-slow {
    box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    transition: box-shadow 0.3s ease-in-out;
  }
  .make-it-slow:hover {
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  }
  .background-pro-guitar {
    background-image: url('/static/img/landing/pro/pro_background_guitar.jpg');
    background-size: cover;
    background-position: right;
  }
  .background-metadata {
    background-image: url('/static/img/landing/pro/metadata_background.jpg');
    background-size: cover;
    background-position: center;
  }
  .btn-absolute-custom {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .padding-right-custom {
    padding-right: 140px;
  }
  @media only screen and (max-width: 1440px)  {}
  @media screen and (max-width: 1366px) {}
  @media screen and (max-width: 1024px) {}
  @media only screen and (max-width: 768px)  {}
  @media screen and (max-width: 578px) {}
  @media screen and (max-width: 400px) {}
  @media screen and (max-width: 320px) {}
</style>



// WEBPACK FOOTER //
// src/components/Distributions.vue